<template>
  <pt-batch-add-lab-order class="pt-batch-add-lab-order__withData" v-loading="loading" :billDetail="data"></pt-batch-add-lab-order>
</template>

<script>
import PtBatchAddLabOrder from './index'
export default {
  name: 'pt-batch-add-lab-order__withData',
  components: {
    'pt-batch-add-lab-order': PtBatchAddLabOrder
	},
	data(){
		return{
			data:{},
			loading:false,
			billId:''
		}
	},
	methods:{
		    // 加载委托单详情数据
    load () {
      console.log('------load')
      this.loading = true
      this.$store.dispatch('getBill', this.billId).then((data) => {
        this.loading = false
        this.data = data
      }).catch((error) => {
        this.loading = false
        console.error(error)
        this.$message.error(error || '获取委托单信息失败！')
      })
    },
	},
	created(){
		this.billId=this.$route.query.billId
		if(this.billId) this.load()
	}
}
</script>
